var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"policies"},_vm._l((_vm.policies),function(policy,index){return _c('Policy',{key:index,attrs:{"policy":policy}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }